import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable()
export class RouteVariantService {
  private baseUrl = environment.routeUrl + environment.apiVersionRoute;

  constructor(private http: HttpClient) {
  }

  getLineVariantShapeStatus(routeVariantIds: number[]): Observable<{ routeVariants: {routeVariantId: number, shapeExists: boolean}[] }> {
    const url = `${this.baseUrl}/routes/variants/shape-exists?routeVariantIds=${routeVariantIds.join(',')}`;
    return this.http.get<{ routeVariants: {routeVariantId: number, shapeExists: boolean}[] }>(url);
  }
}
